<template>
    <v-container fluid>
        <v-row>
          <v-col
            v-for="(image) in images"
            :key="image.ID"
            class="d-flex child-flex"
            :lg="lg"
            :md="md"
            :sm="sm"
            :xs="xs"
          >
            <v-card flat tile class="d-flex">
              <v-img
                :src="`${image.sizes.thumbnail}`"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                  >
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-btn
                absolute
                dark
                fab
                bottom
                right
                small
                color="red"
                class="mb-8"
                @click="$emit('delete:image', image)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  data() {
      return {

      }
  },
  props: {
    images : {
      required: true,
    },
    lg : {
      required: false,
      default:  2
    },
    md : {
      required: false,
      default:  3
    },
    sm : {
      required: false,
      default:  6
    },
    xs : {
      required: false,
      default:  12
    }
  },
}
</script>